import {RootState} from '../store'

export const selectTableros = (state: RootState) => state.tableros.list
export const selectTablerosStatus = (state: RootState) => state.tableros.status
export const selectTablerosFiltroFavorito = (state: RootState) =>
  state.tableros.filstrandoPorFavoritos
